export function notNull(item) {
    return item !== null;
}
export function notUndefined(item) {
    return typeof item !== 'undefined';
}
export function notNullOrUndefined(item) {
    return item !== null && typeof item !== 'undefined';
}
